import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AceHwyInbondArrivalKeys from 'src/constants/locale/key/AceHwyInbondArrival'

const ACEHwyInbondArrivalTranslationText = () => {
    const { translate } = useTranslation([
        Namespace.ACE_HIGHWAY_INBOND_ARRIVAL
    ])
    let loginUserId = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.LOGIN_USER_ID)
    let functionCode = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.FUNCTION_CODE)
    let auditDescription = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.AUDIT_DESC)
    let createdDate = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.CREATED_DATE)
    let createdSuccessMsg = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.CREATED_SUCCESS_MESSAGE)
    let submitSuccessMsg = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.SUBMIT_SUCCESS_MESSAGE)
    let submitFailMsg =  translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.SUBMIT_FAIL_MESSAGE)
    let title = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.TITLE)
    let tripNo= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.TRIP_NO)
    let etaFirstPortUS= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.ETA_FIRST_PORT_US)
    let firstPort= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.FIRST_PORT)
    let inbond7512No= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.INBOND7512_NO)
    let inbondDate= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.INBOND_DATE)
    let inbondDestination= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.INBOND_DESTINATION)
    let firmsCode= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.FIRMS_CODE)
    let msgFunction= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.MSG_FUNCTION)
    let messageCode= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.MESSAGE_CODE)
    let id= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.ID)
    let createdBy= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.CREATED_BY)
    let updatedBy= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.UPDATED_BY)
    let updatedDate= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.UPDATED_DATE)
    let submittedBy= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.SUBMITTED_BY)
    let submittedDate= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.SUBMITTED_DATE)
    let version= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.VERSION)
    let partyId= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.PARTY_ID)
    let arrivalStatus= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.ARRIVAL_STATUS)
    let exportStatus= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.EXPORT_STATUS)
    let useManifestButton = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.USE_MANIFEST)
    let inbondDepartureDate = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.INBOND_DEPARTURE_DATE)
    let responseTitle=translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.RESPONSE_TITLE)
    let deletesuccessMsg= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.DELETE_SUCCESS)
    let uploadIBStandAlone= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.UPLOAD_IB_STAND_ALONE)
    let createIBFromManifest= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.CREATE_IB_FROM_MANIFEST)
    let createIBStandAlone= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.CREATE_IB_STAND_ALONE)
    let editSentRecords= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.EDIT_SENT_RECORD)
    let editButton= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.EDIT_BUTTON)
    let deleteButton= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.DELETE_BUTTON)
    let submitButton= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.SUBMIT_BUTTON)
    let cloneButton= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.CLONE_BUTTON)
    let submitInvalidMsg= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.SUBMIT_INVALID_MSG)
    let deleteConfirmationMsg= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.DELETE_CONFIRMATION_MSG)
    let deleteConfirmButton= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.DELETE_CONFIRMATION_BUTTON)
    let deleteCancelButton= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.DELETE_CANCEL_BUTTON)
    let past15Days= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.PAST_15_DAYS)
    let past30Days= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.PAST_30_DAYS)
    let past60Days= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.PAST_60_DAYS)
    let lastModifiedDate=translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.LAST_MODIFIED_DATE)

    let responseDate = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.RESPONSE_DATE)
    let CBPRefNo = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.CBP_REF_NO)
    let batchId = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.BATCH_ID)
    let responseCode = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.RESPONSE_CODE)
    let responseText = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.RESPONSE_TEXT)
    let submissionType = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.SUBMISSION_TYPE)

    let errorCode = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.ERROR_CODE)
    let rejectType = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.REJECT_TYPE)
    let errorDesc = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.ERROR_DESC)

    let activityLogTitle = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.ACTIVITYLOG_TITLE)
    let inbondArrivalTabName = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.INBOND_ARRIVAL_TAB)
    let inbondResponseTabName = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.INBOND_RESPONSE_TAB)
    let activityLogTabName = translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.ACTIVITY_LOG_TAB)
    let manifestTitle= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.MANIFEST_TITLE)
    let exportOfInbondNumber= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.EXPORT_OF_INBOND)
    let arrivalOfInbondNumber= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.ARRIVAL_OF_INBOND)
    let notReceivedMessage= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.NOT_RECEIVED)
    let inbondAppliedSuccessMsg= translate(Namespace.ACE_HIGHWAY_INBOND_ARRIVAL, AceHwyInbondArrivalKeys.INBOND_APPELIED_SUCCESS_MESSAGE)

    
    return {
        loginUserId,
        functionCode,
        auditDescription,
        createdDate,
        createdSuccessMsg,
        submitSuccessMsg,
        errorCode,
        rejectType,
        errorDesc,
        title,
        tripNo,
        etaFirstPortUS,
        firstPort,
        inbond7512No,
        inbondDate,
        inbondDestination,
        firmsCode,
        msgFunction,
        messageCode,
        id,
        createdBy,
        updatedBy,
        updatedDate,
        submittedBy,
        submittedDate,
        version,
        partyId,
        arrivalStatus,
        exportStatus,
        useManifestButton,
        inbondDepartureDate,
        responseTitle,
        deletesuccessMsg,
        uploadIBStandAlone,
        createIBFromManifest,
        createIBStandAlone,
        submitFailMsg,
        editSentRecords,
        editButton,
        deleteButton,
        submitButton,
        cloneButton,
        submitInvalidMsg,
        deleteCancelButton,
        deleteConfirmButton,
        deleteConfirmationMsg,
        past15Days,
        past30Days,
        past60Days,
        lastModifiedDate,
        responseDate,
        responseCode,
        responseText,
        batchId,
        CBPRefNo,
        submissionType,
        activityLogTitle,
        inbondArrivalTabName,
        inbondResponseTabName,
        activityLogTabName,
        manifestTitle,
        exportOfInbondNumber,
        arrivalOfInbondNumber,
        notReceivedMessage,
        inbondAppliedSuccessMsg
    }
}

export default ACEHwyInbondArrivalTranslationText